import { useContext } from 'react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../../../../Layout.component';
import { IndividualPluginRunProps } from '../../types';
import { useIndividualPluginForm } from '../useIndividualPluginForm';

export const useIndividualPluginModal = ({
  runPluginKey,
  successMessage,
  errorMessage,
}: IndividualPluginRunProps) => {
  const { applicationUuid, actionContexts, setLastApplicationUpdate } =
    useContext(ApplicationContext);

  const {
    action: { key },
  } = useContext(DocumentDetailsViewActionContext);

  const modalApi: UseOpenCloseReturn = actionContexts[key].modal;

  const onSuccess = useEventHandler(() => setLastApplicationUpdate(new Date()));

  const form = useIndividualPluginForm({
    modalApi,
    uuid: applicationUuid,
    runOptions: { pluginKey: runPluginKey, successMessage, errorMessage },
    onSuccess,
  });

  return { modalApi, ...form };
};
